// extracted by mini-css-extract-plugin
module.exports = {"reviewPostMasonry":"review-module--review-post-masonry--3IHUm","reviewPostMasonryColumn":"review-module--review-post-masonry-column--3JD87"};